export default __webpack_public_path__ + "static/media/padlock@3x.d99c2480.png";